<template>
    <projeto-resultados 
        :projeto-id="projetoIdBase" 
        :titulo="titulo" 
        :colunas="colunas" 
        :rubrica="rubrica" 
        :componente="componente" 
        :endpoint="endpoint" 
        @update="update"

        :chave-permissao="chavePermissao"
        :projeto-editavel="projetoEditavel"
    />
</template>
<script>
import helpers from "@/common/utils/helpers";
import ProjetoResultados from "../componentes/Resultados"
export default {
    components : {
        ProjetoResultados
    },
    props : ['projetoId', 'projetoIdBase', 'endpoint', 'chavePermissao', 'projetoEditavel'],
    data : () => ({
        colunas : [
            { key: 'tipo', label: "Tipo",
                formatter: (value) => {
                    if (value) return  helpers.getEnum(value).text;
                },
            },
            { key: "dataPublicacao", label:"Data",
                formatter: (value) => {
                    if (value) return helpers.formatarDataBr(value);
                },
            },
            { key: "nomeDaPublicacao", label: "Nome da publicação", },
            { key: "pais", label: "Pais", },
            { key: "titulo", label: "Titulo", },
        ],
        componente : 'producao-cientifica',
        rubrica : 'producao-cientifica',
        titulo : 'Produção Científica / Capacitação Técnológica',
    }),
    methods : {
        update : function(){
            this.$emit('update');
        }
    }
}
</script>
<style>
    
</style>